module.exports = __webpack_public_path__ + "static/media/jcb.17062b31.svg";